import React, {useEffect, useMemo, useState} from "react";

import {
    MapContainer,
    Marker,
    TileLayer,
    useMap,
    useMapEvents,
} from "react-leaflet";

import L from "leaflet";

import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

import "leaflet/dist/leaflet.css";
import "../common/map.css";


const mapMarkerIcon = new L.Icon({
    iconUrl: markerIcon,
    iconRetinaUrl: markerIcon2x,
    shadowUrl: markerShadow,

    iconSize: [25, 41],
    iconAnchor: [12, 41],

    popupAnchor: [1, -34],

    shadowSize: [41, 41],
});


const toCoordinate = (value) => {
    if (
        value === null ||
        value === undefined ||
        value === ""
    ) {
        return null;
    }

    const number = Number(value);

    return Number.isFinite(number)
        ? number
        : null;
};


const normalizePoint = (value) => {
    const lat =
        toCoordinate(value?.lat);

    const lng =
        toCoordinate(value?.lng);


    if (
        lat === null ||
        lng === null ||
        lat < -90 ||
        lat > 90 ||
        lng < -180 ||
        lng > 180
    ) {
        return null;
    }


    return {
        lat,
        lng,
    };
};


const Recenter = ({
    center,
}) => {

    const map =
        useMap();


    useEffect(() => {
        if (!center) {
            return;
        }

        map.setView(
            [
                center.lat,
                center.lng,
            ],

            map.getZoom(),

            {
                animate: false,
            }
        );

    }, [
        center?.lat,
        center?.lng,
        map,
    ]);


    return null;
};


const ZoomGuard = ({
    enabled,
    onEnable,
    onDisable,
}) => {

    const map =
        useMapEvents({
            click() {
                onEnable();
            },

            mouseout() {
                onDisable();
            },
        });


    useEffect(() => {
        if (enabled) {
            map.scrollWheelZoom.enable();
        } else {
            map.scrollWheelZoom.disable();
        }

    }, [
        enabled,
        map,
    ]);


    useEffect(() => {
        const handleKeyDown = (
            event
        ) => {
            if (
                event.key === "Escape"
            ) {
                onDisable();
            }
        };


        document.addEventListener(
            "keydown",
            handleKeyDown
        );


        return () => {
            document.removeEventListener(
                "keydown",
                handleKeyDown
            );
        };

    }, [
        onDisable,
    ]);


    return null;
};


const ReadonlyMap = ({
    point,

    tr = {},

    zoom = 14,
    height = 220,
}) => {

    const [
        wheelEnabled,
        setWheelEnabled,
    ] = useState(false);


    const center =
        useMemo(
            () =>
                normalizePoint(
                    point
                ),

            [
                point?.lat,
                point?.lng,
            ]
        );


    if (!center) {
        return null;
    }


    return (
        <div
            className={[
                "map-wrapper",

                wheelEnabled
                    ? "map-wheel-on"
                    : "map-wheel-off",
            ]
                .filter(Boolean)
                .join(" ")}
        >

            {!wheelEnabled && (
                <div className="map-hint">
                    {
                        tr.click_to_zoom ||
                        "Click map to enable zoom"
                    }
                </div>
            )}


            <MapContainer
                center={[
                    center.lat,
                    center.lng,
                ]}

                zoom={zoom}

                scrollWheelZoom={false}

                style={{
                    height,
                    width: "100%",
                }}
            >

                <Recenter
                    center={
                        center
                    }
                />


                <TileLayer
                    attribution="&copy; OpenStreetMap contributors"

                    url={
                        "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    }
                />


                <ZoomGuard
                    enabled={
                        wheelEnabled
                    }

                    onEnable={() =>
                        setWheelEnabled(
                            true
                        )
                    }

                    onDisable={() =>
                        setWheelEnabled(
                            false
                        )
                    }
                />


                <Marker
                    position={[
                        center.lat,
                        center.lng,
                    ]}

                    icon={
                        mapMarkerIcon
                    }

                    interactive={
                        false
                    }
                />

            </MapContainer>

        </div>
    );
};


export default ReadonlyMap;